import { render, staticRenderFns } from "./Fuente-mod.vue?vue&type=template&id=3cc98404"
import script from "./Fuente-mod.vue?vue&type=script&lang=js"
export * from "./Fuente-mod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports